import {
  types,
  Instance,
  SnapshotIn,
  SnapshotOut,
  getRoot,
} from 'mobx-state-tree';
import { RootModelType } from './Root';
import { modelWithCRUD } from './utils/modelWithCRUD';

export const UserRole = types.frozen<{
  id: number;
  date_joined: string;
  role: string;
  is_admin: boolean;
  is_salesman: boolean;
  is_purchaser: boolean;
  is_warehouse_employee: boolean;
  organisation: number;
  user: number;
}>();

export const User = types
  .model('User', {
    id: types.union(types.identifier, types.identifierNumber),
    first_name: types.optional(types.string, ''),
    last_name: types.optional(types.string, ''),
    email: types.string,
    phone: types.maybeNull(types.string),
    organisation_memberships: types.array(UserRole),
  })
  .views((self) => ({
    get name(): string {
      return self.first_name + ' ' + self.last_name;
    },
    get initials(): string {
      if (self.first_name && self.last_name) {
        return (self.first_name[0] + self.last_name[0]).toUpperCase();
      }
      return self.first_name.slice(0, 2).toUpperCase();
    },
  }));

export interface IUser extends Instance<typeof User> {}
export interface IUserSnapshotIn extends SnapshotIn<typeof User> {}

export const TeamMember = types.model('TeamMember', {
  id: types.union(types.identifier, types.identifierNumber),
  user: User,
  is_owner: types.optional(types.boolean, false),
  is_admin: types.optional(types.boolean, false),
  is_salesman: types.optional(types.boolean, false),
  is_purchaser: types.optional(types.boolean, false),
  is_warehouse_employee: types.optional(types.boolean, false),
});

export const TeamMemberStore = modelWithCRUD('members', TeamMember).named(
  'TeamMemberStore'
);

export interface ITeamMember extends Instance<typeof TeamMember> {}
export interface ITeamMemberSnapshotIn extends SnapshotIn<typeof TeamMember> {}
export interface ITeamMemberSnapshotOut
  extends SnapshotOut<typeof TeamMember> {}

export const TeamMemberReference = types.reference(TeamMember, {
  get(identifier, parent): any {
    return (getRoot(parent!) as RootModelType).teamMemberStore.getItemNaive(
      identifier
    );
  },
  set(value) {
    return value.id;
  },
});
